// Shared helpers for handheld-scanner support (keyboard wedge + feedback)
let _actx;

export function beep(kind = "ok") {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    _actx = _actx || new AC();
    if (_actx.state === "suspended") _actx.resume();
    const o = _actx.createOscillator();
    const g = _actx.createGain();
    o.connect(g);
    g.connect(_actx.destination);
    const map = {
      ok: [920, 0.12, "square"],
      warn: [200, 0.3, "sawtooth"],
      dup: [540, 0.16, "square"],
    };
    const [f, d, t] = map[kind] || map.ok;
    o.type = t;
    o.frequency.value = f;
    g.gain.setValueAtTime(0.09, _actx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, _actx.currentTime + d);
    o.start();
    o.stop(_actx.currentTime + d);
  } catch (_e) {
    /* audio not available */
  }
}

// Normalize a scanned code / SKU: trim, uppercase, strip whitespace
export const normSku = (s) => String(s || "").trim().toUpperCase().replace(/\s+/g, "");
